$(document).on("turbolinks:load", () => {
  const $recalculateButtons = $(".js-recalculate-button");

  if ($recalculateButtons.length > 0) {
    $recalculateButtons.each(function () {
      const $button = $(this);
      const isFinanceClosed = $button.data("finance-closed");

      // Only enable the button if finance is not closed.
      if (!isFinanceClosed) {
        const $form = $button.closest("form.button_to");
        const $spinnerSpan = $form.siblings(".js-recalculate-spinner");

        $button.prop("disabled", false).removeClass("is-visibly-disabled");
        $form.show();
        $spinnerSpan.addClass("d-none");
      }
    });

    $recalculateButtons.off("click.recalculate").on("click.recalculate", function (event) {
      const $clickedButton = $(this);

      if ($clickedButton.prop("disabled")) {
        event.preventDefault();
        return false;
      }

      setTimeout(() => {
        $recalculateButtons.each(function () {
          const $button = $(this);
          const $form = $button.closest("form.button_to");
          const $spinnerSpan = $form.siblings(".js-recalculate-spinner");

          if ($button[0] === $clickedButton[0]) {
            if ($spinnerSpan.length) {
              const formWidth = $form.outerWidth();
              $spinnerSpan.css("min-width", formWidth + "px").removeClass("d-none");
              $form.hide();
            } else {
              $button.prop("disabled", true);
              $button.addClass("is-visibly-disabled");
            }
            $button.prop("disabled", true);
          } else {
            $button.prop("disabled", true).addClass("is-visibly-disabled");
            if ($spinnerSpan.length) {
              $spinnerSpan.addClass("d-none");
            }
          }
        });
      }, 0);
    });
  }

  $(document).on("click", ".js-activate", function (event) {
    const toggle = $(event.target).data("activates");
    $(`.js-activate-panel[data-activates=${toggle}]`).addClass("d-none");
    $(`#${toggle}`).removeClass("d-none");

    // For some reason select2 often misses hidden elements, so this ensures
    // that they get select2-ized whenever the panel gets opened.
    const addedItemEvent = new CustomEvent("has_many_add:after", {
      detail: { toggle: toggle },
    });
    document.dispatchEvent(addedItemEvent);
  });

  $(document).on("click", "#shipment_ports_overriden", (e) => {
    const disabled = !e.target.checked;
    $("#shipment_loading_port_id").prop("disabled", disabled);
    $("#shipment_discharge_port_id").prop("disabled", disabled);
  });

  $(document).on("click", "#shipment_etd_overriden", (e) => {
    const disabled = !e.target.checked;
    $("#shipment_estimated_departure").prop("disabled", disabled);
  });

  $(function () {
    $('[data-toggle="tooltip"]').tooltip();
  });
});
